import {PlantSelect} from '@hconnect/common/components'
import {PlantSelectOption} from '@hconnect/common/hproduce/types'
import {PageContainer} from '@hconnect/uikit/src/lib2'
import {useUpmPlantsContext, getPlantName} from '@hconnect/upm'
import {generatePath, Navigate} from 'react-router'

import {useNavAccessContext} from '../../shared/hooks/useNavAccessContext'
import {useTranslationPrefix} from '../hooks/useTranslationPrefix'

type PerformancePlantSelectProps = {
  path: string
}

export const PerformancePlantSelect: React.FC<PerformancePlantSelectProps> = ({path}) => {
  const {allowedPlants} = useNavAccessContext()
  const {performancePrefix} = useTranslationPrefix()

  const upmPlants = useUpmPlantsContext()

  const plantsList: PlantSelectOption[] = allowedPlants.map((plantId) => {
    return {
      plantId,
      plantName: getPlantName(upmPlants, plantId),
      url: generatePath(path, {plantId})
    }
  })

  if (plantsList.length === 1) {
    return <Navigate to={plantsList[0].url} />
  }

  return (
    <PageContainer>
      <PlantSelect plants={plantsList} translationPrefix={performancePrefix} />
    </PageContainer>
  )
}
